export const MONTHS_AR = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

export function formatMonthLabel(month, year) {
  const index = Number(month) - 1;
  if (!Number.isInteger(index) || index < 0 || index > 11) {
    return `${month}/${year}`;
  }
  return `${MONTHS_AR[index]} ${year}`;
}

export function addCalendarMonths(month, year, offset) {
  const total = Number(year) * 12 + (Number(month) - 1) + Number(offset);
  return {
    year: Math.floor(total / 12),
    month: (total % 12) + 1,
  };
}

export function roundMoney(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

export function moneyCents(value) {
  return Math.round(roundMoney(value) * 100);
}

/** Equal split in cents. The last month takes the remainder. */
export function splitInstallmentAmounts(total, count) {
  const n = Math.trunc(Number(count));
  const cents = moneyCents(total);
  if (!Number.isFinite(cents) || n < 1) return [];
  if (cents <= 0) return Array.from({ length: n }, () => 0);
  const base = Math.floor(cents / n);
  const amounts = Array.from({ length: n }, () => base / 100);
  amounts[n - 1] = (cents - base * (n - 1)) / 100;
  return amounts;
}

export function sumMoney(values) {
  const cents = (values || []).reduce((sum, value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return sum;
    return sum + Math.round(num * 100);
  }, 0);
  return cents / 100;
}

/**
 * Deduction months start the calendar month after approval.
 * `fromDate` is the approval day (defaults to today).
 */
export function deductionMonthLabels(count, fromDate = new Date()) {
  const n = Math.max(0, Math.trunc(Number(count)) || 0);
  const start = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 1);
  return Array.from({ length: n }, (_, index) => {
    const date = new Date(start.getFullYear(), start.getMonth() + index, 1);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return {
      key: `${year}-${month}`,
      label: `${MONTHS_AR[date.getMonth()]} ${year}`,
    };
  });
}

export function scheduleMatchesLoan(values, total) {
  const amounts = (values || []).map((value) => Number(value));
  const invalid = amounts.some((amount) => !Number.isFinite(amount) || amount <= 0);
  const sum = sumMoney(amounts);
  const target = roundMoney(total);
  return {
    amounts,
    sum,
    target,
    matches: !invalid && amounts.length > 0 && moneyCents(sum) === moneyCents(target),
  };
}

/** Keep a hand-edited schedule only when it already sums to the loan. */
export function scheduleForApproval(existing, total, count) {
  const n = Math.trunc(Number(count));
  const status = scheduleMatchesLoan(existing, total);
  if (Array.isArray(existing) && existing.length === n && status.matches) {
    return existing.map((value) => String(value));
  }
  return splitInstallmentAmounts(total, n).map((amount) => String(amount));
}
